export const SectionHeader = ({ overline, title, description, action }) => {
  return (
    <div className="flex items-end justify-between mb-8 gap-4 flex-wrap">
      <div>
        {overline && <div className="label-overline mb-2">{overline}</div>}
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight font-light text-[#212421]">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-sm text-[#696E69] max-w-xl leading-relaxed">{description}</p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
};
